import { createActions, createReducer } from "reduxsauce"
import { LOAD } from "../../../actions/localStore"

export const { Types, Creators } = createActions({
  setSeenNewFeature: ["feature"],
  loadNewFeature: [],
}, {
  prefix: "ompnt/modules/newFeature/",
})

const DEFAULT_STATE = {
  features: {},
}

function handleSetSeenNewFeature(state, { feature }) {
  const data = { seen: true }
  const newState = {
    ...state,
    features: {
      ...state.features,
      [feature]: data,
    },
  }

  localStorage.setItem("new-features", JSON.stringify(newState))

  return newState
}

function handleLoadNewFeature(state) {
  const storageState = JSON.parse(localStorage.getItem("new-features"))
  return { ...state, ...storageState }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_SEEN_NEW_FEATURE]: handleSetSeenNewFeature,
  [LOAD]: handleLoadNewFeature,
})
